import { getCurrentUser, setCurrentUser, User } from "utils/user";
import { HttpStatusCode } from "constants/globals";
import requestTypes from "constants/requestTypes";
import "isomorphic-fetch"
import { refreshTokenService } from "./keycloakApi";
import { encodeFormData } from "./utils";

const request = async (url: string, options: RequestInit): Promise<any> => {
  try {
    const resp = await fetch(url, options);
    const data = await resp.json();
    return data;
  } catch (error) {
    throw error;
  }
};

const obtainNewAccessToken = async (
  user: User,
  url: string,
  options: {
    method: string;
    headers: {
      "Content-Type": string;
      Authorization: string;
      Accept: string;
    };
    body?: any;
  }
) => {
  try {
    const resp = await refreshTokenService(user.refresh_token);
    const status = resp.status;
    const respJson = await resp.json();

    if (status === HttpStatusCode.OK) {
      const currentTime = Date.now() / 1000;
      const expires_in = currentTime + Number(respJson.expires_in);
      let respJsonTemp = { ...respJson, expires_in };
      setCurrentUser(respJsonTemp);
      options.headers.Authorization = `${"Bearer "}${respJson ? respJson.access_token : ""}`;
      const resp = await request(url, options);
      return resp;
    } else {
      throw {
        status,
        ...respJson,
      };
    }
  } catch (error) {
    throw error;
  }
};

export const fetchNext = async (type: string, url: string, bodyData: Object) => {
  const user = getCurrentUser();

  let options = {
    method: type,
    headers: {
      "Content-Type": "application/json",
      Authorization: `${"Bearer "}${user ? user.access_token : ""}`,
      Accept: `application/json;`,
    },
    body: "",
  };

  if (bodyData && type !== requestTypes.GET) {
    options = { ...options, body: encodeFormData(bodyData) };
  } else {
    delete options.body;
  }

  const currentTime = Date.now() / 1000;

  if (user && currentTime < Number(user.expires_in)) {
    try {
      const resp = await request(url, options);
      if (resp && resp.data) {
        return resp;
      } else {
        throw resp;
      }
    } catch (error) {
      if (
        error &&
        error.error &&
        error.error.status === HttpStatusCode.Unauthorized &&
        error.error.reason === "AuthenticationError"
      ) {
        try {
          return await obtainNewAccessToken(user, url, options);
        } catch (error) {
          throw error;
        }
      }
      throw error;
    }
  } else {
    try {
      return await obtainNewAccessToken(user, url, options);
    } catch (error) {
      throw error;
    }
  }
};
